import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Countdown from 'react-countdown';
import koreanLocale from 'moment/locale/ko';
import Button from '../../components/button/index';
import VideoPlayer from '../../components/videoPlayer';
import Icon from '../../icon';
import useCoursePromotionPage from './styles';
import { useTheme } from '../../theme/theming';
import { formatCurrency } from '../../utils/currencyUtils';
import { wordBreakValue } from '../../utils/cssUtils';

const SingleVideoSlide = (props) => {
  const [isReadMore, setIsReadMore] = useState(false);

  const theme = useTheme();
  useEffect(() => {
    // remaining days epoch
    // current date epoch
    // subtract remaining days from current day epoch
    // moment the result - and see if there are days
    // days is present show days
    // else start reverse timer
  }, []);

  const {
    data,
    webinarCtaClick,
    conversions = 0,
    countryCode,
    currencySymbol
  } = props;
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (days === 0 && hours < 24) {
      if (countryCode === 'KR') {
        return (
          <span>
            {hours} 시간 {minutes} 분 {seconds}초
          </span>
        );
      }
      return (
        <span>
          {hours}h {minutes}m {seconds}s
        </span>
      );
    } else {
      let given = moment(props.data.offerPriceEndDate);
      let current = moment().startOf('day');
      return (
        <span>
          {Math.floor(moment.duration(given.diff(current)).asDays())}{' '}
          {countryCode === 'KR' ? '일' : 'day(s)'}
        </span>
      );
    }
  };

  const checkIfOfferIsValid = () =>
    moment().diff(moment(props.data.offerPriceEndDate)) < 0;

  const checkForShowDiscount = () => {
    if (props.data.endDate === null || checkIfOfferIsValid()) {
      if (data.discount > 0 && data.offerPriceValidFor === null) {
        return true;
      } else if (
        data.discount > 0 &&
        data.offerPriceValidFor !== null &&
        data.offerPriceValidFor - conversions <= 0
      ) {
        return false;
      }
    } else if (data.offerPriceValidFor >= null && data.discount) {
      if (data.offerPriceValidFor <= conversions) {
        return false;
      }
      if (data.offerPriceValidFor - conversions < 0) {
        return false;
      } else {
        return true;
      }
    }
    if (data.discount > 0) {
      return true;
    }
  };

  const discount = ({ price, discount }) => {
    return ((discount / price) * 100).toFixed(2);
  };
  const classes = useCoursePromotionPage();
  const effectivePrice = formatCurrency(
    countryCode,
    data?.effectivePrice,
    currencySymbol
  );
  const renderHurryUpBannerText = () => {
    let count = data.offerPriceValidFor - conversions;
    if (countryCode === 'KR') {
      if (count > 1) {
        return `서두르세요! 현재 신청 가능 인원은 ${count}명 입니다.`;
      } else {
        return `서두르세요! ${count}명까지만 신청 가능이 가능합니다.`;
      }
    } else {
      return `Hurry up! Offer left for ${count} ${
        count > 1 ? 'users now' : 'user only'
      }`;
    }
  };
  const limitedPeriodOfferText =
    countryCode === 'KR'
      ? '기간 한정 딜이므로 서두르세요!'
      : 'Hurry up! Offer for limited period only';

  const renderOfferEndsInText = () => {
    if (countryCode === 'KR') {
      return (
        <p className={classes.offerText}>
          <span className={classes.courseDetailTime}>
            <Countdown renderer={renderer} date={data.offerPriceEndDate} />
          </span>{' '}
          후 신청 마감 예정
        </p>
      );
    } else {
      return (
        <p className={classes.offerText}>
          Offer Ends in{' '}
          <span className={classes.courseDetailTime}>
            <Countdown renderer={renderer} date={data.offerPriceEndDate} />
          </span>
        </p>
      );
    }
  };

  const handleReadMoreText = () => {
    if (countryCode === 'KR') {
      return '더 보기';
    } else {
      return 'Read More';
    }
  };

  const finalPrice = formatCurrency(countryCode, data?.price, currencySymbol);

  const buyNowText = countryCode === 'KR' ? '수강신청하기' : 'BUY NOW';
  const registerNowText =
    countryCode === 'KR' ? '웨비나 신청하기' : 'REGISTER NOW';

  const momentLocale = countryCode === 'KR' ? 'ko' : 'in';
  if (countryCode === 'KR') {
    moment.updateLocale('ko', koreanLocale);
  } else {
    moment.locale('en');
  }

  return (
    <div className={classes.videoCarouselContainer}>
      <div className={classes.webinarCarousel}>
        <div className={classes.iframeSuperContainer}>
          <div className={classes.videoDetails}>
            {data?.isPaid !== 0 &&
              (checkIfOfferIsValid() || data.offerPriceValidFor > 0) && (
                <div>
                  {data.offerPriceValidFor > conversions &&
                  (data.discount && data.offerPriceEndDate
                    ? checkIfOfferIsValid()
                    : true) ? (
                    <div className={classes.bannerContainer}>
                      <div className={classes.bannerContainerText}>
                        {renderHurryUpBannerText()}
                      </div>
                    </div>
                  ) : checkIfOfferIsValid() &&
                    data.offerPriceValidFor !== null ? (
                    data.offerPriceValidFor - conversions > 0
                  ) : (
                    true && (
                      <div className={classes.bannerContainer}>
                        <div className={classes.bannerContainerText}>
                          {limitedPeriodOfferText}
                        </div>
                      </div>
                    )
                  )}
                </div>
              )}

            <h3
              ref={data?.videoTextHeading?.refSetter}
              className={classes.videoDetailsHeading}
              dangerouslySetInnerHTML={{
                __html: data.title
              }}
            />
            <div className={classes.courseDetailsTags}>
              <div className={classes.courseDetailTag}>
                <span className={classes.iconBackground}>
                  <Icon
                    name={'Calendar'}
                    width="24px"
                    color={theme?.colors?.background2}
                  />
                </span>
                <div>
                  {moment(data.startDate)
                    .locale(momentLocale)
                    .format('Do MMM YY') + ' '}
                  {moment(data.startTime).locale(momentLocale).format('h:mm A')}
                  <span> - </span>
                  {moment(data.endTime).locale(momentLocale).format('h:mm A')}
                </div>
              </div>
              <div className={classes.courseDetailTag}>
                <span className={classes.iconBackground}>
                  <Icon
                    color={theme?.colors?.background2}
                    width="24px"
                    name={`${
                      data.webinarLocation === 'Location' ? 'Location' : 'Video'
                    }`}
                  />
                </span>
                <div>
                  {data.webinarLocation === 'Location'
                    ? data.webinarLink
                    : data.webinarLocation}
                </div>
              </div>
            </div>
            <p
              ref={data?.videoTextContent?.refSetter}
              className={classes.courseDetailContent}
              dangerouslySetInnerHTML={{
                __html: isReadMore
                  ? data.description
                  : data.description.substring(0, 250)
              }}
            />
            <p
              onClick={() => {
                setIsReadMore(true);
              }}
              ref={data?.videoTextSubContent?.refSetter}
              className={classes.courseDetailViewFullDetails}
              dangerouslySetInnerHTML={{
                __html:
                  data.description.length > 250 && !isReadMore
                    ? handleReadMoreText()
                    : null
              }}
            />
          </div>
        </div>
        <div className={classes.courseViewContainer}>
          {data.isPaid !== 0 &&
            checkIfOfferIsValid() &&
            (data.offerPriceValidFor !== null
              ? data.offerPriceValidFor - conversions > 0
              : true) &&
            renderOfferEndsInText()}

          <div
            ref={data?.videoFrame?.refSetter}
            className={classes.iframeContainer}
          >
            <VideoPlayer
              onlyThumbnail
              imageUrl={data.thumbnail}
              videoUrl={data.thumbnail}
              sectionIndex={props?.sectionIndex}
            />
          </div>
          <div
            style={{
              display: data.isPaid ? 'flex' : 'block'
            }}
            className={classes.bottomContainer}
          >
            {data.isPaid !== 0 ? (
              <div className={classes.priceContainer}>
                <div className={classes.offerPrice}>{effectivePrice}</div>
                {checkForShowDiscount() &&
                  (data.offerPriceEndDate ? checkIfOfferIsValid() : true) && (
                    <p
                      style={{
                        fontSize: '20px'
                      }}
                    >
                      <span className={classes.originalPrice}>
                        {finalPrice}
                      </span>{' '}
                      {
                        <span className={classes.offerDiscount}>{`${
                          data && discount(data)
                        }%`}</span>
                      }
                    </p>
                  )}
              </div>
            ) : null}
            <div className={classes.webinarButtonContainer}>
              <Button
                style={{
                  width: data.isPaid ? '100%' : '100%',
                  fontSize: 'large',
                  wordBreak: wordBreakValue('KR')
                }}
                data={{
                  // link: 'headerData?.loginCtaLink',
                  // isLink: 1,
                  value: data.isPaid ? buyNowText : registerNowText
                  // isExternal: 1
                }}
                onClick={webinarCtaClick}
                type={'primary'}
                size={'medium'}
                target={null}
                rel={null}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleVideoSlide;
